module.exports = __webpack_public_path__ + "img/icon_quality.b45078b8.png";